import { projectHomeRedirect } from "@/features/projects/utils/project-home-destination";
import { Outlet, createFileRoute } from "@tanstack/react-router";

// CR-183 D8: the contributor's only project pages. Anyone else lands on the
// project's resolved home (Change Requests unless that module is off).
// CR-235 D8: a layout, so the guard covers the list (index) and each
// suggestion's own page ($suggestionId).
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions",
)({
  beforeLoad: ({ context, params }) => {
    if (context.projectAccess !== "contributor") {
      throw projectHomeRedirect(context.project, params, context.workspaceAccess);
    }
  },
  component: Outlet,
});
